<div class="estoque-card">
  <div class="card-header-row">
    <h3 class="section-title">
      <i class="pi pi-box"></i>
      {{ texts.estoque_limitado }}
    </h3>
    <button pButton type="button"
            [label]="texts.ver_todos"
            class="p-button-text p-button-sm"
            icon="pi pi-external-link"
            (click)="abrirDialogEstoque()">
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
  </div>

  <!-- Tabela -->
  <div *ngIf="!loading && produtos.length > 0">
    <p-table [value]="produtos" [paginator]="false" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 50px">#</th>
          <th>{{ texts.nome_produto }}</th>
          <th class="text-right" style="width: 100px">{{ texts.quantidade }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-produto let-rowIndex="rowIndex">
        <tr [class.linha-par]="rowIndex % 2 === 0"
            class="linha-clicavel"
            (click)="irParaProduto(produto)">
          <td>{{ rowIndex + 1 }}</td>
          <td>{{ produto.nome }}</td>
          <td class="text-right qtd-alerta">{{ produto.saldo }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && produtos.length === 0" class="empty-state">
    <i class="pi pi-inbox"></i>
  </div>
</div>

<!-- Dialog de Estoque Limitado -->
<p-dialog [(visible)]="showDialogEstoque"
          [modal]="true"
          [style]="{ width: '720px' }"
          [breakpoints]="{ '768px': '95vw' }"
          [draggable]="false"
          [resizable]="false"
          [showHeader]="false"
          styleClass="dialog-wave-estoque">

  <!-- Wave Header -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-box" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.estoque_limitado }}</h2>
        <p *ngIf="produtosDialog.length > 0">
          {{ produtosDialog.length }} {{ texts.produto }}{{ produtosDialog.length > 1 ? 's' : '' }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Lista de produtos em cards -->
  <div *ngIf="produtosDialog.length > 0" class="dialog-produto-list">
    <div *ngFor="let produto of produtosDialog; let i = index; trackBy: trackByProdutoId"
         class="produto-card-item produto-card-clicavel"
         [class.produto-card-critico]="produto.saldo === 0"
         (click)="irParaProduto(produto)">

      <!-- Foto do produto -->
      <div class="produto-card-foto">
        <img *ngIf="produtoTemImagemValida(produto)"
             [src]="getImagemUrl(produto.imagem!)"
             [alt]="produto.nome"
             class="produto-card-img"
             (error)="onImageError(produto)" />
        <div *ngIf="!produtoTemImagemValida(produto)" class="produto-card-img-placeholder">
          <i class="pi pi-image"></i>
        </div>
      </div>

      <!-- Informacoes do produto -->
      <div class="produto-card-info">
        <div class="produto-card-nome">{{ produto.nome }}</div>
        <div class="produto-card-codigo" *ngIf="produto.codigoItem">
          {{ texts.codigo }}: {{ produto.codigoItem }}
        </div>
        <div class="produto-card-precos">
          <span class="produto-card-preco">
            {{ texts.compra }}: <strong>{{ produto.custo | currency:'':'':'1.0-0' }}</strong>
          </span>
          <span class="produto-card-preco">
            {{ texts.venda }}: <strong>{{ produto.precoDeVenda | currency:'':'':'1.0-0' }}</strong>
          </span>
          <span class="produto-card-minimo">
            {{ texts.minimo }}: <strong>{{ produto.estoqueMinimo }}</strong>
          </span>
        </div>
      </div>

      <!-- Quantidade -->
      <div class="produto-card-qtd"
           [class.qtd-alerta]="produto.saldo <= produto.estoqueMinimo && produto.saldo > 0"
           [class.qtd-zero]="produto.saldo === 0">
        <span class="produto-card-qtd-valor">{{ produto.saldo }}</span>
        <span class="produto-card-qtd-label">{{ texts.quantidade }}</span>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="produtosDialog.length === 0" class="empty-state">
    <i class="pi pi-inbox"></i>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button"
            [label]="texts.fechar"
            icon="pi pi-times"
            class="p-button-outlined"
            (click)="showDialogEstoque = false">
    </button>
  </ng-template>
</p-dialog>
